//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum ContentCardBlockVariant {
	Yellow = "yellow",
	LightGreyPrimary = "lightGreyPrimary",
	BlackPrimary = "blackPrimary",
	DarkGreyPrimary = "darkGreyPrimary",
	LightGreySecondary = "lightGreySecondary",
	BlackSecondary = "blackSecondary",
	DarkGreySecondary = "darkGreySecondary",
	Blue = "blue",
	DarkRed = "darkRed",
	LightTransparent = "lightTransparent",
	DarkTransparent = "darkTransparent",
	Legacy = "legacy"
}
